import i18n from "../../../../i18n"

export async function affExternalShipmentsUseCase(status, page, per_page, search, sort_by, externalShipmentRepository) {
    const result = await externalShipmentRepository.get_aff_index_orders(status, page, per_page, search, sort_by);
    var pending_actions = [
        {
            name: i18n.t('advanced_fulfillment_pendings.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'showDetails',
        },
        {
            name: i18n.t('advanced_fulfillment_pendings.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: '',
        },
        {
            name: i18n.t('advanced_fulfillment_pendings.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
        },
        {
            name: i18n.t('advanced_fulfillment_pendings.prepare'),
            icon: {
                color: 'accent',
                icon: 'send'
            },
            method: 'prepareSingleOrder',
        }
    ];

    var to_be_supplied_actions = [
        {
            name: i18n.t('advanced_fulfillment_to_be_supplied.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'showDetails',
        },
        {
            name: i18n.t('advanced_fulfillment_to_be_supplied.supply'),
            icon: {
                color: 'accent',
                icon: 'send'
            },
            method: 'singleOrderSupply',
        }
    ];

    var supplied_actions = [
        {
            name: i18n.t('advanced_fulfillment_supplied.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'showDetails',
        },
        {
            name: i18n.t('advanced_fulfillment_supplied.download_label'),
            icon: {
                color: 'accent',
                icon: 'label'
            },
            method: 'downloadLabelExt',
        },
        {
            name: i18n.t('advanced_fulfillment_supplied.restore'),
            icon: {
                color: 'accent',
                icon: 'history'
            },
            method: 'askRestore',
        }
    ];

    var sent_actions = [
        {
            name: i18n.t('advanced_fulfillment_sent.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'showDetails',
        },
        {
            name: i18n.t('advanced_fulfillment_sent.edit'),
            icon: {
                color: 'accent',
                icon: 'mode_edit'
            },
            link: '/sent-shipments/cod/edit/10000',
        },
        {
            name: i18n.t('fulfillments_cod_in_process.restore'),
            icon: {
                color: 'accent',
                icon: 'history'
            },
            method: 'askRestore',
        },
        {
            name: i18n.t('advanced_fulfillment_sent.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
        },
    ];

    var returned_actions = [
        {
            name: i18n.t('advanced_fulfillment_returned.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'showDetails',
        },
        {
            name: i18n.t('advanced_fulfillment_returned.incidence'),
            icon: {
                color: 'accent',
                icon: 'warning_amber'
            },
            link: '/shipments/cod/incidence/10000',
        },
        {
            name: i18n.t('advanced_fulfillment_returned.restore'),
            icon: {
                color: 'accent',
                icon: 'restore'
            },
            method: 'askRestore',
        },
    ];

    for (var i = 0; i < result.data.data.length; i++) {
        result.data.data[i] = result.data.data[i].attributes;

        const entity = new externalShipmentRepository.aff_model(result.data.data[i]);

        if (!entity.isValid()) {
            console.log(entity)
            throw new Error("External Shipments Aff Index Inválido");
        }

        if (status == "pending_orders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(pending_actions));
            result.data.data[i]['actions'][1].link = "/external_shipments/edit_pending/" + result.data.data[i].id;
        }
        else if (status == "confirmed_orders") result.data.data[i]['actions'] = JSON.parse(JSON.stringify(to_be_supplied_actions));
        else if (status == "supplied_orders") result.data.data[i]['actions'] = JSON.parse(JSON.stringify(supplied_actions));
        else if (status == "sent_orders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(sent_actions));
            result.data.data[i]['actions'][1].link = "/sent-shipments/prepaid/edit/" + result.data.data[i].id;
        }
        else if (status == "returned_orders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(returned_actions));
            result.data.data[i]['actions'][1].link = "/shipments/prepaid/incidence/" + result.data.data[i].id;
        }

        result.data.data[i].parameters = result.data.data[i].id;
    }

    return result;
}